$(document).on('click', '.btn-video-play', function(e){
  e.preventDefault();
  $("#youtube").attr('src', $(this).data('src') + '?autoplay=1&rel=0');
  $("body").addClass("show-video-modal noscroll");
});

function close_video_modal() {
        
  event.preventDefault();

  // re-hide the video modal
  $("body").removeClass("show-video-modal noscroll");

  // reset the source attribute for the iframe template, kills the video
  $("#youtube").attr('src', '');
  
}
// if the 'close' button/element, or the overlay are clicked 
$(document).on('click', '.close-video-modal, .video-modal .overlay', function(event) {
    
    // call the close and reset function
    close_video_modal();
    
});
// if the ESC key is tapped
$('body').keyup(function(e) {
    // ESC key maps to keycode `27`
    if (e.keyCode == 27) { 
      
      // call the close and reset function
      close_video_modal();
      
    }
});
